import * as React from 'react';
import { LoadingOutlined } from '@ant-design/icons';

/**
 * Shared button spinner for the login screen. Lives here rather than in
 * `components/pages/Login` so the layout components can use it without
 * importing their own parent (which would be a circular import).
 */
export const loginAntIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
